import { render, staticRenderFns } from "./StartModal.vue?vue&type=template&id=bd533da6&scoped=true"
import script from "./StartModal.vue?vue&type=script&lang=js"
export * from "./StartModal.vue?vue&type=script&lang=js"
import style0 from "./StartModal.vue?vue&type=style&index=0&id=bd533da6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd533da6",
  null
  
)

export default component.exports